import { useLiveExactLimits } from '../../hooks/useLiveExactLimits';
import { ExactLimits } from '../ScenarioRun/RunDetail/ExactLimits';
import { mergeLimits } from '../ScenarioRun/RunDetail/exactLimitsModel';

/**
 * Exact's day and minute of one environment, live: why messages wait, and how fast a customer
 * runs into the limit. Nothing is shown before the connector reported its first reading.
 */
export const LiveExactLimits = ({
    customer,
    environment,
}: {
    customer: string;
    environment: string;
}) => {
    const board = useLiveExactLimits(customer, environment);
    const limits = mergeLimits(undefined, board);

    return limits ? <ExactLimits limits={limits} running compact /> : null;
};
